import {PORTAL_KEY} from 'core/env'

const keyHeaders = (headers = {}) => ({
  headers: {
    ...headers,
    'x-luminopia-monitoring-portal-key': PORTAL_KEY ,
  },
})
export default keyHeaders



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/keyHeaders.ts